/**
 * Resolves the DOM element that `UnifiedSelectPopover` anchors itself to.
 *
 * MUST be called synchronously inside the same click/drag event handler that
 * updates `MultiCellSelection` state (or the `onMultiSelectionChange` callback
 * passed to `AvailabilityGrid`, which itself fires synchronously from a click/drag
 * handler) — NOT from a `useEffect` reacting to the selection state. React fires
 * `useLayoutEffect`s bottom-up (children before parents) within a commit, so a
 * parent-level `useEffect`/`useLayoutEffect` that re-queries the DOM for the anchor
 * AFTER `UnifiedSelectPopover` has already mounted and run its own positioning
 * `useLayoutEffect` leaves the popover reading a stale or null anchor ref for that
 * commit — it renders pinned to the viewport's default (0,0) origin instead of next
 * to the clicked cell. Resolving the anchor element in the same synchronous tick as
 * the state update guarantees the ref is already correct before that commit happens.
 */
export function resolveMultiSelectAnchorElement(testId: string): HTMLElement | null {
  return document.querySelector<HTMLElement>(`[data-testid="${testId}"]`);
}

/** Builds the `data-testid` for a multi-select anchor cell from its grid ref. */
export function buildMultiSelectAnchorTestId(
  prefix: string,
  unitId: string,
  periodId: string,
): string {
  return `${prefix}-${unitId}-${periodId}`;
}
